export default "/assets/ico-toggle-off.png";